import script from "D:\\Kryzalis\\proquimil.com.br-2023\\frontend\\src\\assets\\js\\components\\LogoKryzalis.vue?type=script"
export * from "D:\\Kryzalis\\proquimil.com.br-2023\\frontend\\src\\assets\\js\\components\\LogoKryzalis.vue?type=script"
import { render } from "D:\\Kryzalis\\proquimil.com.br-2023\\frontend\\src\\assets\\js\\components\\LogoKryzalis.vue?type=template"

script.render = render
export default script